import { FC } from "react";
import Icon from "../../../Icon/Icon";
import { IconColorE, IconSizeE } from "../../../../models/enums";
import type { BatchFileT } from "../../models/models";

import styles from "./fileRow.module.scss";

const MP4 = "mp4";

type FileRowPropTypes = {
  batchFile: BatchFileT;
  onRemove: (id: number) => void;
  progress: number;
  handleShowThumbnail: (e: any, file: any) => void;
  replacedNames: {
    [key: string]: string;
  };
};

const FileRow: FC<FileRowPropTypes> = (props) => {
  const { batchFile, onRemove, progress, handleShowThumbnail, replacedNames } =
    props;
  const {
    file: { size, type },
    name, 
    id,
  } = batchFile;
  const fileName = replacedNames[name.split(".")[0]];

  return (
    <div className={styles.wrapper}>
      <div className={styles.nameWrapper}>
        {type.includes(MP4) && (
          <div
            className={styles.iconPlayWrapper}
            onMouseEnter={(e) => handleShowThumbnail(e, batchFile.file)}
          >
            <Icon name="play" color={IconColorE.WHITE} />
          </div>
        )}
        <span>
          {name} {fileName && fileName !== name && `(${fileName})`}
        </span>
      </div>
      <div className={styles.progressData}>
        <span>{(size / 1024 / 1024).toFixed(0)} MB</span>
        <span className={styles.percentages}>{progress}%</span>
        <Icon
          color={
            progress === 0
              ? IconColorE.BLACK
              : progress === 100
              ? IconColorE.NONE
              : IconColorE.GRAY
          }
          size={IconSizeE.S}
          name={
            progress === 0 ? "bin" : progress === 100 ? "approved" : "loading"
          }
          onClick={() => progress === 0 && onRemove(id)}
          title={progress === 0 ? "Remove file" : `${progress}% uploaded`}
        />
      </div>
    </div>
  );
};

export default FileRow;
